<template>
    <div
        class="form-group"
        v-if="showSelector"
        v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white'}"
    >
        <div v-if="isMixed" class="session-mode">
            <label>{{ $t('sessionMode') }}</label>
            <select v-model="openSession" @change="changeSessionMode">
                <option :value="true" :disabled="!item.free_places">
                    {{ $t('joinOpenSession') }} ({{ $tc('placesLeft', item.free_places, { n: item.free_places }) }})
                </option>
                <option :value="false" :disabled="!item.private_available">
                    {{ $t('privateSession') }} ({{ privatePrice }}€)
                </option>
            </select>
            <small v-if="!openSession">{{ $t('privateSessionInfo', { n: experience.maxPlayers }) }}</small>
        </div>
        <label for=""> {{ $t('Número de personas') }}</label>
        <select v-if="scheduleDesktop" v-model="idPriceSelected" @change="changeNumber">
            <option :value="index" v-for="(price, index) in pricesList" v-bind:key="index" v-if="price.full_price > 0">
                {{ price.people }} {{ $t('PERSONAS') }} &nbsp;&nbsp;&nbsp;&nbsp; {{ (price.full_price/price.people).toFixed(2) }}€/{{ $t('PERSONA') }} &nbsp;&nbsp;&nbsp;&nbsp; {{ price.text }}
            </option>
        </select>
        <select v-else v-model="idPriceSelected" name="" id="" @change="changeNumber">
            <option :value="index" v-for="(price, index) in pricesList" v-bind:key="index">
                {{ price.people }}
                {{ $t('PERSONAS') }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {{ (price.full_price/price.people).toFixed(2) }}€/{{ $t('PERSONA') }} &nbsp;&nbsp;&nbsp;&nbsp;
                {{ price.text }}
            </option>
        </select>
    </div>
</template>

<script>

    import { mapMutations } from 'vuex';
    import { mapGetters } from 'vuex';

    import { getPricesList, privateSessionPrice } from '../../../../helpers';

    export default {
        props: ["room","experience","id_field","start","item"],
        name: "player-selector",
        data() {
            return {
                idPriceSelected: 0,
                scheduleDesktop: false,
                scheduleMobile: false,
                isFixedPlayers: false,
                openSession: this.item ? Boolean(this.item.open_session) : false,
            }
        },
        computed: {
            ...mapGetters(['getCheckout','getDesign','getNumPlayerItems','getExperiences']),
            showSelector() {
                return !this.isFixedPlayers;
            },
            // Los precios se leen siempre por aqui, que tolera las dos formas de la API.
            // En una sesion abierta solo se ofrecen hasta las plazas que quedan.
            pricesList() {
                const prices = getPricesList(this.experience);
                if (!this.openSession || !this.item || this.item.free_places === null) {
                    return prices;
                }

                return prices.filter(price => price.people <= this.item.free_places);
            },
            isMixed() {
                return this.experience.groupType === 'mix' && Boolean(this.item);
            },
            // Coger en privado una sesion de Ambos paga todas las plazas.
            privatePrice() {
                return privateSessionPrice(this.experience);
            }
        },
        created() {
            this.checkDevice();
            this.isFixedPlayers = this.hasFixedPlayers();
            let number = this.getNumPlayerItems({id_experience: this.experience.id, id_calendario : this.room});

            if (this.isFixedPlayers) {
                this.idPriceSelected = this.getPositionValue(this.experience.minPlayers);
            } else if(number) {
                this.idPriceSelected = this.getPositionValue(number);
            }
            this.changeNumber();
        },
        methods: {
            ...mapMutations(['updatePeopleNumber', 'updateItemOpenSession']),
            changeSessionMode: function () {
                this.updateItemOpenSession({id_experience: this.experience.id, id_calendario: this.room, start: this.start, open_session: this.openSession});
                if (this.idPriceSelected >= this.pricesList.length) {
                    this.idPriceSelected = 0;
                }
                this.changeNumber();
            },
            checkDevice: function () {
                const toMatch = [
                    /Android/i,
                    /iPhone/i,
                    /iPad/i,
                    /iPod/i,
                    /BlackBerry/i,
                    /Windows Phone/i
                ];
                this.scheduleMobile = toMatch.some((toMatchItem) => {
                    return navigator.userAgent.match(toMatchItem);
                });
                this.scheduleDesktop = !this.scheduleMobile;
            },
            hasFixedPlayers: function () {
                const minPlayers = this.experience?.minPlayers;
                const maxPlayers = this.experience?.maxPlayers;
                return minPlayers === maxPlayers;
            },
            getPositionValue: function (value) {
                const position = this.pricesList.findIndex(price => price.people === value);
                return position >= 0 ? position : 0;
            },
            changeNumber: function () {
                const selected = this.pricesList[this.idPriceSelected];
                if (!selected) {
                    return;
                }
                let people = selected.people;
                let price = this.isMixed && !this.openSession && this.privatePrice !== null ? this.privatePrice : selected.full_price;
                this.updatePeopleNumber({id: this.id_field, id_experience: this.experience.id, id_calendario : this.room, people: people, price: price, start: this.start});
                if(this.getCheckout().id) {
                    this.$emit('change-field')
                }
            }
        }
    }
</script>

<style scoped>

</style>
